import axiosInstance from "../Axios/axiosInstance";

const getAllInsurances = async () => {
  return await axiosInstance.get("/medicalInsurances/");
};

const getInsuranceById = async (id) => {
  return await axiosInstance.get(`/medicalInsurances/${id}`);
};

const addInsurance = async (data) => {
  console.log(data);
  const formData = new FormData();
  formData.append("document", data.file);
  formData.append("class", data.class);
  formData.append("mapping", data.mapping);
  formData.append("description", data.description);
  formData.append("ar_description", data.ar_description);
  return await axiosInstance.post("/medicalInsurances/", formData);
};

const editInsurance = async (id, data) => {
  const formData = new FormData();
  if (data.file != null) formData.append("document", data.file);
  if (data.class != null) formData.append("class", data.class);
  if (data.mapping != null) formData.append("mapping", data.mapping);
  if (data.description != null)
    formData.append("description", data.description);
  if (data.ar_description != null)
    formData.append("ar_description", data.ar_description);
  if (data.isPreview != null) formData.append("isPreview", data.isPreview);
  return await axiosInstance.put(`/medicalInsurances/${id}`, formData);
};

const deleteInsurance = async (id) => {
  return await axiosInstance.delete(`/medicalInsurances/${id}`);
};

export default {
  getAllInsurances,
  getInsuranceById,
  addInsurance,
  editInsurance,
  deleteInsurance,
};
